<template>
  <div>
    <md-toolbar class="md-warn">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <b>AVAILABLE COMPANIES</b>
          <md-field>
            <md-icon>search</md-icon>
            <label>Company</label>
            <md-input v-model="companyPrefix"></md-input>
          </md-field>
        </div>
      </div>
    </md-toolbar>
    <md-card
      v-for="tenant in companiesWhereIamAdmin"
      v-bind:key="tenant.Id"
      class="md-primary"
      md-theme="green-card"
      md-with-hover
      v-on:click.native="companyClicked(tenant)"
    >
      <md-card-header>
        <md-card-header-text>
          <div class="md-title">{{tenant.TenantName}}</div>
          <div class="md-subhead">domain: <b>{{tenant.Domain}}</b></div>
        </md-card-header-text>

        <md-card-media>
          <img
            :src="IMAGE_SERVER_URL+'company/'+tenant.Id+'.jpg?width=75'"
            alt="Avatar"
            onerror="this.style.display='none'"
          >
        </md-card-media>
      </md-card-header>
    </md-card>
  </div>
</template>
<script>
import auth from "./auth";

export default {
  name: "Index",
  data: () => ({
    user: {
      Tenants: [],
      AdminOfTenants: [],
    },
    IMAGE_SERVER_URL: process.env.VUE_APP_IMAGE_SERVER,
    companyPrefix: "",
  }),
  async mounted() {
    this.user = JSON.parse((await auth.manager.getUser()).profile.userinfo);
  },

  computed: {
    companiesWhereIamAdmin() {
      return this.user.Tenants.filter(
        (t) =>
          this.user.AdminOfTenants.includes(t.Id) &&
          (t.Domain?.toLowerCase().includes(
            this.companyPrefix?.toLowerCase()
          ) ||
            t.TenantName?.toLowerCase().includes(
              this.companyPrefix?.toLowerCase()
            ))
      ).sort((a, b) => a.Domain.localeCompare(b.Domain));
    },
  },
  methods: {
    companyClicked(company) {
      this.$router.push({
        name: "ComapnySettings",
        params: { company: company.Domain },
      });
    },
  },
};
</script>
<style lang="css" scoped>
.white {
  color: white;
}
</style>
